import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import PublicShell from "../components/PublicShell";

const PHONE = "+963 969 137 301";
const PHONE_RAW = "+963969137301";

const Contact = () => (
  <PublicShell>
    <section className="max-w-2xl mx-auto px-4 py-16 md:py-24" data-testid="contact-page">
      <h1 className="text-4xl md:text-5xl font-extrabold text-[#333333] mb-6 text-center">اتصل بنا</h1>
      <p className="text-center text-[#666666] text-lg mb-8">نسعد بالإجابة على استفساراتك</p>

      <div className="bg-white border border-[#7AB2B2] rounded-2xl p-8 space-y-5">
        <a href={`tel:${PHONE_RAW}`} data-testid="contact-phone-link"
          className="flex items-center gap-4 p-5 rounded-xl bg-[#EBF4F6] hover:bg-[#7AB2B2]/30 transition-colors">
          <div className="w-14 h-14 rounded-xl bg-[#09637E] text-white flex items-center justify-center shrink-0">
            <Phone size={26} />
          </div>
          <div className="flex-1">
            <div className="text-sm font-bold text-[#666666]">رقم الهاتف</div>
            <div className="text-2xl font-extrabold text-[#09637E] tracking-wide" dir="ltr">{PHONE}</div>
          </div>
        </a>

        <a href={`https://wa.me/${PHONE_RAW.replace("+", "")}`} target="_blank" rel="noreferrer" data-testid="contact-whatsapp-link"
          className="flex items-center gap-4 p-5 rounded-xl border-2 border-[#09637E] text-[#09637E] hover:bg-[#EBF4F6] transition-colors">
          <div className="w-14 h-14 rounded-xl bg-[#09637E]/10 flex items-center justify-center shrink-0">
            <MessageCircle size={26} />
          </div>
          <div className="flex-1">
            <div className="text-sm font-bold opacity-80">واتساب</div>
            <div className="text-lg font-extrabold">راسلنا مباشرة على واتساب</div>
          </div>
        </a>
      </div>
    </section>
  </PublicShell>
);

export default Contact;
